export const SHIPPING = {
  // UPS Overnight Airsaver
  EXPRESS: '10',
  // Backend expects 0 for standard shipping
  STANDARD: '0',
  CHECK_ADDRESS: 'https://www.ups.com/address_validator/search?loc=en_US',
  EXPRESS_FEE: 30,
};
